<template>
	<div>
		<vAlert theme="info">{{$t('fbb.carrier.alert', { defaultValue: '录入最大值最小值时，注意范围不要存在交叉重叠' })}}</vAlert>
		<compWrapper :title="$t('fbb.costmanage.base_info', { defaultValue: '基础信息' })" theme="primary">
			<compFormQuery
				v-if="type==='query'"
				align="center"
				class="margin-top-15"
				:formdata="getBase"
				:value="formData"
			></compFormQuery>
			<compFormEdit
				v-else
				ref="formbase"
				align="center"
				class="margin-top-15"
				:formdata="getBase"
				v-model="formData"
			></compFormEdit>
			<footer slot="footer">
				<vButton v-if="type!=='query'" theme="primary" class="margin-right-15" @click="submit">{{$t('global.common.save', { defaultValue: "保存" })}}</vButton>
				<vButton class="margin-right-15" @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</vButton>
			</footer>
		</compWrapper>
		<compLog v-if="type==='query'" :columns="getLogList" wrapper :data="logList"></compLog>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { HttpRule, HttpSaveRule } from '@/service/fedex';
import mixin from '../mixin'
export default {
	mixins: [mixin],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log")
	},
	data() {
		return {
			loading: false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			logList: [],
			formData: {
				ruleRangeType: 'FORMULA'
			}
		};
	},
	created() {
		this.getDetail();
	},
	computed: {
		getBase() {
			const query = this.type === "edit",
				isMaxMin = this.formData.ruleRangeType==='MAXMIN_VALUE';
			return [
				{
					// label: this.$t('fbb.alloment.carrier_server', { defaultValue: '承运商服务' }),
                    label: "承运商服务",
					tag: "vSelect",
					key: "systemCarrierServiceId",
					query,
					options: this.getCarrierServiceOpt,
					props:{
                        filterable:true
                    },
					on: {
						'on-change': this.handleCarrierChange
					}
				},
				{
					label: this.$t('fbb.carrier.ruleLabel', { defaultValue: '规则标识' }),
					tag: "vSelect",
					key: "ruleLabel",
					query,
					options: this.getRulelabelOpt
				},
				{
					label: this.$t('fbb.carrier.ruleRangeType', { defaultValue: '规则匹配类型' }),
					tag: "vSelect",
					key: "ruleRangeType",
					query,
					options: this.getRuleTypeOpt
				},
				{
					label: this.$t('fbb.carrier.ruleRangeFormula', { defaultValue: '匹配公式' }),
					key: "ruleRangeFormula",
					tag: "vTextarea",
					show: !isMaxMin
				},
				{
					label: this.$t('fbb.carrier.ruleRangeMin', { defaultValue: '最小值' }),
					key: "ruleRangeMin",
					tag: "vInputNumber",
					show: isMaxMin
				},
				{
					label: this.$t('fbb.carrier.ruleRangeMax', { defaultValue: '最大值' }),
					key: "ruleRangeMax",
					tag: "vInputNumber",
					show: isMaxMin
				},
				{
					label: this.$t('fbb.carrier.extra_rule_remark', { defaultValue: '规则描述' }),
					tag: "vTextarea",
					key: "remark"
				}
			];
		}
	},
	methods: {
		handleCarrierChange(value, label, attach = {}) {
			this.formData = {
				...this.formData,
				carrierCode: attach.carrierCode,
				carrierServiceCode: attach.carrierServiceCode,
				carrierServiceName: attach.carrierServiceName,
			}
		},
		cancel() {
			this.$router.push({
				name: "carrierRule"
			});
		},
		getDetail() {
			if (this.type === "add") return;
			this.loading = true;
			HttpRule({
				id: this.id,
			}).then(res => {
				const data = res.data || {};
				this.logList = data.carrierRuleLogs;
				delete data.carrierRuleLogs;
				this.formData = data;
				this.loading = false;
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			});
		},
		async submit() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
			this.loading = true;
			HttpSaveRule(this.formData).then(res => {
				this.cancel();
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
	}
};
</script>
